module.exports = __webpack_public_path__ + "fonts/Merriweather-500-vietnamese19.11350f7.woff2";